import { apiService } from './api'


class UserService {
  async getUsers(params?: any) {
    const response = await apiService.api.get('/admin/users', { params })
    return response.data
  }

  async getAllUsers() {
    const response = await apiService.api.get('/admin/users/all')
    return response.data
  }

  async getUser(id: number) {
    const response = await apiService.api.get(`/admin/users/${id}`)
    return response.data
  }

  async createUser(data: any) {
    const response = await apiService.api.post('/admin/users', data)
    return response.data
  }

  async updateUser(id: number, data: any) {
    const response = await apiService.api.put(`/admin/users/${id}`, data)
    return response.data
  }

  async deleteUser(id: number) {
    await apiService.api.delete(`/admin/users/${id}`)
  }

  async getUserStats() {
    const response = await apiService.api.get('/admin/users/stats')
    return response.data
  }
}

export const userService = new UserService()
export default userService